<template>
  <div class="col-12 box-col-6">
    <div class="card">
      <div class="card-header customStickyCardHeader">
        <div>
          <div class="mb-0 f-16" style="align-self: center">
            {{ $t("lbl_EMPBE_NewsCenterDesc") }}
            <i id="direction-tooltip-right" class="fa fa-info-circle m-l-5" v-b-toggle="'news_info_popup'"
              v-bind:t_label="'EMPBE_NewsInfoCenter_titleInfo'"></i>
          </div>
        </div>
        <span class=""> * {{ $t("lbl_EMPBE_NewsTerms") }} </span>
      </div>
      <div class="card-body">
        <div class="email-left-aside">
          <div class="mb-3 row" v-if="Records.length <= 0 && user.userType != 'ADMIN'">
            <div class="col-sm-12">
              <b-button variant="outline-primary" class="btn btn-outline-primary p-l-15 d-flex align-items-center"
                v-bind:t_label="'EMPBE_newsInfoCenter_news_btnAddNewWithoutnews'" @click="checkLaunchLimit">
                <feather type="plus-circle"> </feather>
                <span class="m-l-5">{{ $t("lbl_EMPBE_NotHaveNews") }}</span>
              </b-button>
            </div>
          </div>
          <div v-if="Records.length > 0 || user.userType == 'ADMIN'">
            <b-overlay :show="loading" rounded="sm">
              <localization :language="kendoLang">
                <intl :locale="kendoLang">
                  <Grid ref="grid" :data-items="gridData" :resizable="true" :reorderable="true" :sortable="true"
                    :pageable="gridPageable" :groupable="false" :group="group" :sort="sort" :filter="filter" :take="take"
                    :skip="skip" :columns="columns" :column-menu="columnMenuValue" :selectable="true"
                    :selected-field="selectedField" :filterable="true" @headerselectionchange="onHeaderSelectionChange"
                    @datastatechange="dataStateChange" @selectionchange="onSelectionChange"
                    @rowclick="onRowClick">
                    <toolbar>
                      <span class="k-textbox k-grid-search k-display-flex" v-if="false">
                        <b-form-input type="text" :placeholder="$t('lbl_EMPBE_SearchWord')" v-model="searchWord"
                          @input="onFilter"></b-form-input>
                      </span>
                      <span class="export-buttons">
                        <div v-if="user.userType == 'ADMIN'" class="d-flex m-r-15 align-items-center">
                          <span class="m-r-5">{{
                            $t("lbl_EMPBE_ShowDeletedRecord")
                          }}</span>
                          <div class="media-body icon-state">
                            <label class="switch mb-0">
                              <input type="checkbox" v-model="isDelete" />
                              <span class="switch-state"></span>
                            </label>
                          </div>
                        </div>

                        <kbutton :size="'large'" :theme-color="'primary'" @click="checkLaunchLimit"
                          v-bind:t_label="'EMPBE_News_btnAddNew'">
                          <i class="fa fa-plus-circle" style="line-height: 1.5"></i>
                          {{ $t("lbl_EMPBE_Newnews") }}
                        </kbutton>
                        &nbsp;
                        <kbutton :size="'large'" :theme-color="'primary'" disabled v-if="!isAdmin"
                          v-bind:t_label="'EMPBE_NewsInfoCenter_News_btnAddToCart'">
                          <i class="icon-shopping-cart" style="line-height: 1.5;"></i>
                          {{ $t("lbl_EMPBE_ActivateNewsTotal") }}
                          ({{ $t("lbl_EMPBE_Current") }}:{{ ActivatedNewsCount }}/{{ newsActiviateLimit }})
                        </kbutton>
                      </span>
                    </toolbar>
                    <template v-slot:companyNameTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <span>
                          <router-link 
                            :to="'/newsInfoCenter/newsDetail/' + props.dataItem.newsId"
                            custom v-slot="{ navigate }"
                            >
                            <a href="javascript:void(0)" @click="navigate($event)"
                             v-b-toggle="'newsRightpopup'"
                            class="pl-0 no-router-link-exact-active"
                            v-bind:t_label="'EMPBE_newsInfoCenter_news_Comp_' + props.dataItem.newsId">
                            {{props.dataItem.companyName }}
                            </a>
                          </router-link>
                        </span>
                      </td>
                    </template>
                    <template v-slot:newsNameTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <router-link
                          :to="'/newsInfoCenter/newsDetail/' + props.dataItem.newsId" 
                          custom v-slot="{ navigate }"
                          >
                          <a href="javascript:void(0)" @click="navigate($event)"
                          v-b-toggle="'newsRightpopup'"
                          class="pl-0 no-router-link-exact-active"
                          v-bind:t_label="'EMPBE_newsInfoCenter_news_Title_' + props.dataItem.newsId">
                          {{ props.dataItem.title }}
                          </a>
                        </router-link>
                      </td>
                    </template>
                    <template v-slot:publishDateTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <router-link 
                          :to="'/newsInfoCenter/newsDetail/' + props.dataItem.newsId" 
                          custom v-slot="{ navigate }"
                          >
                          <a href="javascript:void(0)" @click="navigate($event)"
                          v-b-toggle="'newsRightpopup'"
                          class="pl-0 no-router-link-exact-active"
                          v-bind:t_label="'EMPBE_newsInfoCenter_news_PublishDate_' + props.dataItem.newsId">
                          
                          {{ displayDate(props.dataItem.publishDate) }}
                          </a>
                        </router-link>
                      </td>
                    </template>
                    <template v-slot:TagsTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <span v-for="tag in props.dataItem.tags" class="badge badge-primary m-5 f-16 text-left"
                          style="white-space: pre-wrap; padding: 0.44em 0.3em">
                          #{{ tag.text }}
                        </span>
                      </td>
                    </template>
                    <template v-slot:lastSaveDateTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <span>
                          {{ props.dataItem.lastSaveDate }}
                        </span>
                        <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="false">
                          <span>{{ $t("lbl_EMPBE_UnsubmittedDraft") }}</span>
                        </span>
                      </td>
                    </template>
                    <template v-slot:StatusTemplate="{ props }">
                      <td v-if="props.rowType !== 'groupHeader'">
                        <span class="badge badge-info m-r-5 m-l-5 f-16" v-if="props.dataItem.statusCode == 'P'">
                          <span>{{ props.dataItem.displayStatus }}</span>
                        </span>
                        <span class="badge badge-success m-r-5 m-l-5 f-16" v-if="props.dataItem.statusCode == 'A'">
                          <span>{{ props.dataItem.displayStatus }}</span>
                        </span>
                        <span class="badge badge-danger m-r-5 m-l-5 f-16" v-if="props.dataItem.statusCode == 'R'">
                          <span>{{ props.dataItem.displayStatus }}</span>
                        </span>
                        <span class="badge badge-light m-r-5 m-l-5 f-16" v-if="props.dataItem.statusCode == 'U'">
                          <span>{{ props.dataItem.displayStatus }}</span>
                        </span>
                        <span class="badge badge-warning m-r-5 m-l-5 f-16" v-if="props.dataItem.statusCode == undefined">
                          <span>{{ $t('lbl_EMPBE_Draft') }}</span>
                        </span>
                      </td>
                    </template>
                    <template v-slot:tagfilterSlotTemplate="{ props, methods }">
                      <div>
                        <DropDownList :data-items="tagData" :text-field="'text'" :value-field="'tagId'" @change="(ev) => {
                          props.onChange({
                            operator: 'contains',
                            field: props.field,
                            value: ev.value.text,
                            syntheticEvent: ev,
                          });
                        }
                          " />
                      </div>
                    </template>
                    <template v-slot:statusfilterSlotTemplate="{ props, methods }">
                      <div>
                        <DropDownList :data-items="statusData" :text-field="'text'" :data-item-key="'id'"
                          v-model="statusItem" @change="(ev) => {
                            statusItem = ev.value;
                            props.onChange({
                              operator: 'contains',
                              field: props.field,
                              value: ev.value.id,
                              syntheticEvent: ev,
                            });
                          }
                            " />
                      </div>
                    </template>
                    <template v-slot:columnMenuTemplate="{ props }">
                      <customColumnMenu :column="props.column" :filterable="props.filterable" :filter="props.filter"
                        :sortable="props.sortable" :sort="props.sort" :columns="columns"
                        @sortchange="(e) => props.onSortchange(e)" @filterchange="(e) => props.onFilterchange(e)"
                        @closemenu="(e) => props.onClosemenu(e)" @contentfocus="(e) => props.onContentfocus(e)"
                        @columnssubmit="onColumnsSubmit" />
                    </template>
                    <template v-slot:filterSlotTemplate="{ props, methods }">
                      <div>
                        <k-input :placeholder="$t('lbl_EMPBE_SearchByKeyword')" :value="props.value" @input="(ev) => {
                          props.onChange({
                            operator: 'contains',
                            field: props.field,
                            value: ev.target.value,
                            syntheticEvent: ev,
                          });
                        }
                          " />
                      </div>
                    </template>
                    <template v-slot:DatefilterSlotTemplate="{ props, methods }">
                      <div>
                        <DropDownList :data-items="dateSortingData" :text-field="'text'" :data-item-key="'value'"
                          :default-item="dateSortingDefault" @change="(ev) => {
                            if (sort.filter(x => x.field == props.field).length > 0) {
                              if (ev.value.value == '') {
                                sort = sort.filter(x => x.field != props.field)
                              } else {
                                sort.find(x => x.field == props.field).dir = ev.value.value
                              }
                            } else if (ev.value.value != '') {
                              sort.push({ dir: ev.value.value, field: props.field })
                            }
                            gridData = getData(items)
                          }
                            " />
                      </div>
                    </template>
                  </Grid>
                </intl>
              </localization>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
    <news_info_popup id="news_info_popup"></news_info_popup>
    <visitorPermissionPopup PopupUid="PopupPermission"></visitorPermissionPopup>
  </div>
</template>

<script>
import { newsService, userService } from "../../_services";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { Input } from "@progress/kendo-vue-inputs";
import { Button } from "@progress/kendo-vue-buttons";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { process } from "@progress/kendo-data-query";
import CustomStartDateInput from '../../components/form/dateRangePicker/customStartDateInput.vue';
import CustomEndDateInput from '../../components/form/dateRangePicker/customEndDateInput.vue';
import { DateRangePicker } from '@progress/kendo-vue-dateinputs';
import news_info_popup from './news_info_popup.vue'
import visitorPermissionPopup from '@/components/visitorPermissionPopup'
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";
import ColumnMenu from "./ColumnMenu";
import { tableKeyboardNavigationHeaderAttributes } from "@progress/kendo-vue-data-tools";

export default {
  props: ["hideSidebarNavMenu", "newsActiviateLimit"],
  components: {
    Grid: Grid,
    toolbar: GridToolbar,
    localization: LocalizationProvider,
    intl: IntlProvider,
    "k-input": Input,
    kbutton: Button,
    DropDownList,
    customColumnMenu: ColumnMenu,
    DateRangePicker,
    CustomStartDateInput,
    CustomEndDateInput,
    news_info_popup,
    visitorPermissionPopup
  },
  data() {
    return {
      props: ['newsActiviateLimit'],
      loading: false,
      Records: [],
      error: null,
      totalRows: 1,
      currentPage: 1,
      items: [],
      filter: this.$route.query.pending
        ? {
          logic: "and",
          filters: [
            {
              field: "displayStatus",
              operator: "contains",
              value: this.$t("lbl_EMPBE_Pending"),
            },
          ],
        }
        : {
          logic: 'and',
          filters: [],
        }, //[20231005][JWS] Defailt loading pending if query have pending
      gridData: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      rowSelected: [],
      skip: 0,
      take: 10,
      group: [],
      sort: [],
      gridPageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
      searchWord: "",
      selectedField: "selected",
      columnMenuValue: false,
      isDelete: false,
      Tags: [],
      Images: [],
      columns: [],
      userColumns: [
        {
          field: "displayName",
          title: this.$t("lbl_EMPBE_Title"),
          cell: "newsNameTemplate",
          filterCell: 'filterSlotTemplate',
        },
        {
          field: "publishDateTime",
          title: this.$t("lbl_emp2_supplierMember_Publish"),
          filter: "date",
          format: "{0:D}",
          cell: "publishDateTemplate",
          filterCell: 'DatefilterSlotTemplate'
        },
        {
          field: "tagsText",
          title: this.$t("Lbl_SearchTag"),
          cell: "TagsTemplate",
          filterCell: 'filterSlotTemplate',
        },
        {
          field: "lastSaveDateTime",
          title: this.$t("lbl_EMPBE_LastSubmit"),
          cell: "lastSaveDateTemplate",
          filter: "date",
          format: "{0:D}",
          filterCell: 'DatefilterSlotTemplate'
        },
        {
          field: "displayStatus",
          title: this.$t("lbl_buyerform_status"),
          cell: "StatusTemplate",
          filterCell: "statusfilterSlotTemplate",
        },
      ],
      adminColumns: [
        {
          field:
            this.langid == "1252"
              ? "nameEng"
              : this.langid == "950"
                ? "nameTrad"
                : "nameSimp",
          title: this.$t("Lbl_CompanyName"),
          cell: "companyNameTemplate",
          filterCell: 'filterSlotTemplate',
        },
        {
          field: "displayName",
          title: this.$t("lbl_EMPBE_Title"),
          cell: "newsNameTemplate",
          filterCell: 'filterSlotTemplate',
        },
        {
          field: "publishDateTime",
          title: this.$t("lbl_emp2_supplierMember_Publish"),
          filter: "date",
          format: "{0:D}",
          cell: "publishDateTemplate",
          filterCell: 'DatefilterSlotTemplate'
        },
        {
          field: "tagsText",
          title: this.$t("Lbl_SearchTag"),
          cell: "TagsTemplate",
          filterCell: 'filterSlotTemplate',
        },
        {
          field: "lastSaveDateTime",
          title: this.$t("lbl_EMPBE_LastSubmit"),
          cell: "lastSaveDateTemplate",
          filter: "date",
          format: "{0:D}",
          filterCell: 'DatefilterSlotTemplate'
        },
        {
          field: "displayStatus",
          title: this.$t("lbl_buyerform_status"),
          cell: "StatusTemplate",
          filterCell: "statusfilterSlotTemplate",
        },
      ],
      statusData: [
        { text: this.$t("Lbl_PleaseSelect"), id: "" },
        { text: this.$t("lbl_EMPBE_Pending"), id: this.$t("lbl_EMPBE_Pending") },
        { text: this.$t("lbl_EMPBE_isActivate"), id: this.$t("lbl_EMPBE_isActivate") },
        { text: this.$t("lbl_EMPBE_Rejected"), id: this.$t("lbl_EMPBE_Rejected") },
        { text: this.$t("lbl_EMPBE_NotSubmitYet"), id: this.$t("lbl_EMPBE_NotSubmitYet") },
        { text: this.$t("lbl_EMPBE_NotActivate"), id: this.$t("lbl_EMPBE_NotActivate") },
      ],
      tagData: [],
      statusItem: this.$route.query.pending ? { text: this.$t("lbl_EMPBE_Pending"), value: this.$t("lbl_EMPBE_Pending") } : { text: this.$t("Lbl_PleaseSelect"), value: "" }, //[20231005][JWS] Defailt loading pending if query have pending

      dateSortingData: [
        { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
        { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
      ],
      dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
      ActivatedNewsCount: 0
    };
  },
  created() {
    this.gridData = this.getData(this.items);
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    isAdmin() {
      return this.user.userType == "ADMIN";
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    sortOptions() {
      // Create an options list from our fields
      return this.tablefields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    selectedDataItems() {
      return this.gridData.data.filter((item) => item.selected === true);
    },
    areAllSelected() {
      return (
        this.selectedDataItems.length === this.gridData.data.length &&
        this.selectedDataItems.length !== 0
      );
    },
    kendoLang() {
      var langid = localStorage.getItem("currentLangId");
      switch (langid) {
        case "1252":
          return "en-US";
        case "950":
          return "zh-Hant";
        case "936":
          return "zh-Hans";
        default:
          return "zh-Hans";
      }
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    Records() {
      this.items = this.Records;
      this.totalRows = this.Records.length;
      this.gridData = this.getData(this.items);
    },
    isDelete() {
      this.init();
    },
  },

  methods: {
    init() {
      // Set the initial number of items
      this.LoadNewsData();
      this.totalRows = this.items.length;
      this.items = this.Records;
      this.totalRows = this.Records.length;
      this.gridData = this.getData(this.items);
    },
    LoadNewsData() {
      var that = this;
      that.loading = true;
      that.columns = that.userColumns;
      var empCompanyId = this.user.empCompanyId;
      if (that.user.userType == "ADMIN") {
        empCompanyId = 0;
        that.columns = that.adminColumns;
      }
      that.Records = [];
      return newsService
        .LoadNewsRecordsList({
          EmpCompanyId: empCompanyId,
          isDelete: that.isDelete,
          langId: that.langid,
        })
        .then((res) => {
          if (res.isSuccessful) {
            that.Records = res.data.newsRecords;
            that.ActivatedNewsCount = that.Records.length;
            that.Tags = res.data.newsTags;
            that.Images = res.data.newsRecords;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    onSelectionChange(event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
    },
    onRowClick(event) {
      if (!event.dataItem || event.dataItem.newsId == null) {
        return;
      }
      this.$router.push("/newsInfoCenter/newsDetail/" + event.dataItem.newsId);
    },
    handleFilterChange: function (ev) {
      this.filter = ev.filter;

      this.gridData = this.getData(this.items);
    },
    createAppState: function (dataState) {
      this.group = dataState.group;
      this.take = dataState.take;
      this.skip = dataState.skip;
      this.sort = dataState.sort;
      this.filter = dataState.filter;

      this.gridData = this.getData(this.items);
    },
    dataStateChange: function (event) {
      this.createAppState(event.data);
    },
    onFilter(e) {
      let inputValue = this.searchWord;
      this.skip = 0;
      if (inputValue !== "") {
        this.filter = {
          logic: "or",
          filters: [
            {
              field: "name",
              operator: "contains",
              value: inputValue,
            },
          ],
        };
      } else this.filter = null;
      this.gridData = this.getData(this.items);
    },
    getData(data) {
      data.forEach((element) => {
        element.tags = this.Tags.filter((x) => {
          return x.newsId === element.newsId;
        });
        var tagsText = "";
        element.tags.forEach((tag) => {
          tagsText += tag.text;
        });
        element.tagsText = tagsText;
        element.image = this.Images.filter((x) => {
          return x.usageUd === element.newsId;
        });
        element.displayName = this.displayTitle(element);
        element.displayStatus = this.displayStatusText(element);
        element.publishDateTime = new Date(element.publishDate);
        element.lastSaveDateTime = new Date(element.lastSaveDate);
      });
      //this.initTagDropdown(data);
      return process(data, {
        take: this.take,
        skip: this.skip,
        group: this.group,
        sort: this.sort,
        filter: this.filter,
      });
    },
    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;
      const tempData = this.items.map((item) => {
        return { ...item, selected: checked };
      });

      const tempGridData = this.gridData.data.map((item) => {
        return { ...item, selected: checked };
      });
      this.gridData.data = tempGridData;
      this.items = tempData;
    },
    openOrderingPage() {
      this.$root.$emit("bv::toggle::collapse", "OrderRightpopup");
    },
    initTagDropdown(data) {
      if (data.length > 0) {
        this.tagData = data
          .map((x) => x.tags)
          .filter((x, idx, xs) => xs.findIndex((y) => y.text === x.text) === idx);
      } else {
        this.tagData = [""];
      }
    },
    displayTitle(element) {
      if (this.langId == "1252") {
        return this.langid == "1252" && element.titleE != ""
          ? element.titleE
          : this.langid == "950" && element.titleT != ""
            ? element.titleT
            : element.titleS != ""
              ? element.titleS
              : this.$t("lbl_EMPBE_Newnews");
      } else if (this.langId == "950") {
        return this.langid == "950" && element.titleT != ""
          ? element.titleT
          : this.langid == "936" && element.titleS != ""
            ? element.titleS
            : element.titleE != ""
              ? element.titleE
              : this.$t("lbl_EMPBE_Newnews");
      } else {
        return this.langid == "936" && element.titleS != ""
          ? element.titleS
          : this.langid == "950" && element.titleT != ""
            ? element.titleT
            : element.titleE != ""
              ? element.titleE
              : this.$t("lbl_EMPBE_Newnews");
      }
    },
    displayStatusText(element) {
      switch (element.statusCode) {
        case "P":
          return this.$t("lbl_EMPBE_Pending");
          break;
        case "A":
          return this.$t("lbl_EMPBE_isActivate");
          break;
        case "R":
          return this.$t("lbl_EMPBE_Rejected");
          break;
        case "U":
          return this.$t("lbl_EMPBE_NotActivate");
          break;
        default:
          return this.$t("lbl_EMPBE_NotSubmitYet");
          break;
      }
    },
    displayDate(dateString) {
      try {
        var date = new Date(dateString);
        var mm = date.getMonth() + 1; // getMonth() is zero-based
        var dd = date.getDate();

        return [
          date.getFullYear() + "-",
          (mm > 9 ? "" : "0") + mm + "-",
          (dd > 9 ? "" : "0") + dd,
        ].join("");
      } catch (ex) {
        return "";
      }
    },
    onDateRangePickerChange(e, props) {
      const currentFilters = this.filter.filters;

      const isDateRangeFilterApplied =
        currentFilters.filter((el) => el.customOperator == props.field).length !== 0;

      if (isDateRangeFilterApplied) {
        const index = currentFilters.map((e) => e.customOperator).indexOf(props.field);
        currentFilters.splice(index, 1);
      }

      var newFilters = [];
      if (e.value.start) {
        newFilters.push({
          field: props.field,
          operator: 'gte',
          value: e.value.start,
        })
      }
      if (e.value.end) {
        newFilters.push({
          field: props.field,
          operator: 'lte',
          value: e.value.end,
        })
      }

      this.filter.filters.push({
        customOperator: props.field,
        logic: 'and',
        filters: newFilters,
      });
      this.gridData = this.getData(this.items);
    },
    checkLaunchLimit() {
      var that = this;
      if (!this.isAdmin && this.ActivatedNewsCount + 1 > this.newsActiviateLimit) {
        var message = that.$t("lbl_EMPBE_OverActivateNewsAmount");
        that.alertMsg(message);
      } else {
        this.$router.replace('/newsInfoCenter/newsDetail/0');
      }
    },
    alertMsg(message) {
      this.$swal({
        text: message,
        showCancelButton: false,
      });
    },
  },
};
</script>
<style>
.k-grid-table {
  width: 100% !important;
}

.k-grid-header-locked>table,
.k-grid-header-wrap>table {
  width: 100% !important;
}
</style>
